'use client';

import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Instagram, Mail } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="w-full" style={{ backgroundColor: 'hsl(35 100% 97%)' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="section-cream texture-cream py-16 sm:py-24 px-4">
        <div className="container mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#D71920] mb-3 sm:mb-4 uppercase tracking-tight">
            About Mo
          </h1>
          <p className="text-lg sm:text-xl text-foreground font-semibold">
            Fresh halal burgers. Real flavor. DMV energy.
          </p>
        </div>
      </section>

      {/* Featured Image Section */}
      <section className="py-12 sm:py-16 section-cream texture-cream px-4">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto">
            <img
              src="/images/uploads/9b5693e8-478e-4b16-ab96-dc211465bc4c.jpg"
              alt="Mo's Burger - Fresh Halal Burgers"
              className="w-full h-auto rounded-2xl sm:rounded-3xl shadow-lg object-cover"
            />
          </div>
        </div>
      </section>

      {/* Location & Hours Section */}
      <section className="py-12 sm:py-16 section-beige px-4">
        <div className="container mx-auto">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-black text-[#D71920] mb-6 uppercase tracking-tight">
              Find Us Today
            </h2>
            <div className="bg-white rounded-2xl sm:rounded-3xl border border-border p-6 sm:p-8">
              <p className="text-base sm:text-lg text-foreground/80 font-medium mb-4">
                Location & Times: To Be Announced
              </p>
              <p className="text-sm sm:text-base text-foreground/70 font-medium">
                Follow @mosburgerdmv on Instagram for today's location and updates.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section - 3 Columns */}
      <section className="py-20 sm:py-24 section-cream texture-cream px-4">
        <div className="container mx-auto">
          <div className="max-w-5xl mx-auto">
            <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
              {/* 1. Background / Our Story */}
              <div className="bg-white rounded-2xl sm:rounded-3xl border border-border p-6 sm:p-8 hover:shadow-md transition-all">
                <h3 className="text-2xl sm:text-3xl font-black text-[#D71920] mb-4 sm:mb-6 uppercase">
                  Our Story
                </h3>
                <p className="text-foreground/80 text-base sm:text-lg leading-relaxed font-medium">
                  Mo's Burger is a halal food truck serving bold, made-to-order smash burgers across the DMV. Built on fresh ingredients, strong flavors, and late-night energy, we bring real food and real flavor to every stop.
                </p>
              </div>

              {/* 2. Catering */}
              <div className="bg-white rounded-2xl sm:rounded-3xl border border-border p-6 sm:p-8 hover:shadow-md transition-all">
                <h3 className="text-2xl sm:text-3xl font-black text-[#D71920] mb-4 sm:mb-6 uppercase">
                  Catering
                </h3>
                <p className="text-foreground/80 text-base sm:text-lg leading-relaxed font-medium mb-6 sm:mb-8">
                  Planning an event? Bring Mo's Burger to your guests with fresh, halal, crowd-favorite meals served hot and made to order.
                </p>
                <Button
                  onClick={() => window.location.href = 'mailto:Catering@mosburgerdc.com?subject=Mo\'s%20Burger%20Catering%20Inquiry'}
                  className="w-full bg-[#D71920] hover:bg-[#B01017] text-white font-black text-base sm:text-lg py-3 sm:py-4 inline-flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition-all"
                >
                  <Mail className="h-5 w-5 sm:h-6 sm:w-6" />
                  Request Catering
                </Button>
              </div>

              {/* 3. Join Our Community */}
              <div className="bg-white rounded-2xl sm:rounded-3xl border border-border p-6 sm:p-8 hover:shadow-md transition-all">
                <h3 className="text-2xl sm:text-3xl font-black text-[#D71920] mb-4 sm:mb-6 uppercase">
                  Join Our Community
                </h3>
                <p className="text-foreground/80 text-base sm:text-lg leading-relaxed font-medium mb-6 sm:mb-8">
                  Follow us on social media for updates, new items, and exclusive content.
                </p>
                <Button
                  onClick={() => window.open('https://www.instagram.com/mosburgerdmv/', '_blank')}
                  className="w-full bg-gray-800 hover:bg-gray-900 text-white font-black text-base sm:text-lg py-3 sm:py-4 inline-flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition-all"
                >
                  <Instagram className="h-5 w-5 sm:h-6 sm:w-6" />
                  Follow @mosburgerdmv
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
